<template lang="pug">
b-modal#editPartners(
  ref="editPartners"
  :title="$t('ui.combine.edit_partners')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][6] }) }}
    b-form-group.w-100(:label="$t('ui.image')").mb-0
      b-form-file(
        :dirty="$v.img.$dirty"
        :error="$v.img.$error"
        v-model.trim.lazy="$v.img.$model"
        ref="file"
        accept="image/jpeg, image/png, image/jpg"
        @change="onSelect"
        v-if="imgSrc == null"
      )
      small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
      ValidateResult(:value="$v.img" :name="$t('ui.image')")
      SubmitButton(
        :loading="loading"
        icon="fa fa-times"
        :text="$t('ui.remove')"
        type="button"
        @click="removeImage()"
        variant="danger"
        size="sm"
        v-if="imgSrc != null"
        )
      template(v-if="imgSrc != null")
        br
        b-img.w-50.h-50(:src="imgSrc")
    b-form-group(:label="$t('ui.link')").mb-0
      DebounceInput(
        size="sm"
        ref="href"
        type="text"
        v-model="href"
        :disabled="loading"
      )
      small.form-text.text-muted {{ $t('message.tooltips_partners_link') }}
    b-form-group(:label="$t('ui.partner_name')").mb-0
      DebounceInput(
        size="sm"
        ref="partner_name"
        type="text"
        v-model="partner_name"
        :disabled="loading"
      )

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import $ from 'jquery';
const fileSizeValidation = (value) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      partner_id: 0,
      img_url: "",
      img: null,
      imageName: "",
      imgSrc: null,
      href: "",
      partner_name: ""
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    img: {
      required : requiredIf(function () {
        return this.imgSrc == null;
      }),
      fileSizeValidation
    }
  },
  watch: {
    img(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSrc = value;
            })
            .catch(() => {
              this.imgSrc = null;
            });
        } else {
          this.imgSrc = null;
        }
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeImage() {
      this.img = null;
      this.img_url = "";
      this.imageName = "";
      this.imgSrc = null;
    },
    onSelect(evt) {
      if(evt.target.files.length > 0){
        this.imageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.partnersEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        partner_id: this.partner_id,
        img_url: this.img_url,
        href: this.href,
        partner_name: this.partner_name
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editPartners.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_partners", this.feedback.status);
                this.$refs.editPartners.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadImage() {
      if (this.imageName == "") return;

      const formData = new FormData();
      formData.append("file", this.img);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.img_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadImage();
      const someResult = await p1;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.partner_id = this.item.id;
      this.href = this.item.href
      this.partner_name = this.item.partner_name
      this.imgSrc = this.item.img_url != null ? config.viewImageUrl + this.item.img_url : null;
      this.img_url = this.item.img_url;
      this.imageName = "";
      $("#editPartners").find('.modal-content').first().removeAttr('tabindex');
    }
  }
};
</script>
